__turbopack_context__.v({
  "root": "Sidebar-module-scss-module__YOBJUW__root",
  "sidebar-container": "Sidebar-module-scss-module__YOBJUW__sidebar-container",
  "sidebar-container-inner": "Sidebar-module-scss-module__YOBJUW__sidebar-container-inner",
  "sidebar-container-inner-wrapper": "Sidebar-module-scss-module__YOBJUW__sidebar-container-inner-wrapper",
  "sidebar-main": "Sidebar-module-scss-module__YOBJUW__sidebar-main",
  "sidebar-overlay": "Sidebar-module-scss-module__YOBJUW__sidebar-overlay",
});
